const normalizeText = (value) => String(value ?? '').trim();

const toTime = (value) => {
  const time = new Date(value ?? 0).getTime();

  return Number.isFinite(time) ? time : 0;
};

export const sortText = (a, b) =>
  normalizeText(a).localeCompare(normalizeText(b), 'ko', {
    numeric: true,
    sensitivity: 'base',
  });

export const sortDate = (a, b) => toTime(a) - toTime(b);

export const sortByText = (selector) => (a, b) => sortText(selector(a), selector(b));

export const sortByDate = (selector) => (a, b) => sortDate(selector(a), selector(b));
